import React from "react";
// import { Pie } from "react-chartjs-2";
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";

const LeftLeave = ({ text, Num }) => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" color="textSecondary">
          {text}
        </Typography>
        <Typography variant="h4">{Num}</Typography>
      </CardContent>
    </Card>
  );
};

export default { LeftLeave };
